<template>
  <div class="class-1">
    <!-- Header -->
    <AppHeader />

    <!-- Update Delivery Company Form -->
    <div class="container mt-4">
      <div class="row">
        <div class="col-12">
          <h2>Update Delivery Company</h2>
          <form @submit.prevent="handleUpdate">
            <!-- English Name Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="name_en">English Name</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="name_en" 
                    v-model="form.name_en"
                    placeholder="Enter English Name" 
                    required
                    ref="nameEnInput"
                  >
                  <div class="input-group-append">
                    <span 
                      class="input-group-text" 
                      @click="openKeypad('nameEnInput')"
                    >
                      <i class="fas fa-keyboard"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Arabic Name Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="name_ar">Arabic Name</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="name_ar" 
                    v-model="form.name_ar"
                    placeholder="Enter Arabic Name" 
                    required
                    ref="nameArInput"
                  >
                  <div class="input-group-append">
                    <span 
                      class="input-group-text" 
                      @click="openKeypad('nameArInput')"
                    >
                      <i class="fas fa-keyboard"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Person Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="contact_person">Contact Person</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="contact_person" 
                  v-model="form.contact_person"
                  placeholder="Enter contact person name"
                >
              </div>
            </div>

            <!-- Contact Email Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="contact_email">Contact Email</label>
                <input 
                  type="email" 
                  class="form-control" 
                  id="contact_email" 
                  v-model="form.contact_email"
                  placeholder="Enter contact email"
                >
              </div>
            </div>

            <!-- Contact Phone Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="contact_phone">Contact Phone</label>
                <div class="input-group">
                  <input 
                    type="tel" 
                    class="form-control" 
                    id="contact_phone" 
                    v-model="form.contact_phone"
                    placeholder="Enter contact phone number"
                    ref="contactPhoneInput"
                  >
                  <div class="input-group-append">
                    <span 
                      class="input-group-text" 
                      @click="openKeypad('contactPhoneInput')"
                    >
                      <i class="fas fa-keyboard"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dealing Type Select -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="dealing_type">Dealing Type</label>
                <select 
                  class="form-control" 
                  id="dealing_type" 
                  v-model="form.dealing_type"
                  required
                >
                  <option value="1">Percentage Based</option>
                  <option value="2">Fixed Amount</option>
                  <option value="3">Both Percentage and Fixed</option>
                </select>
              </div>
            </div>

            <!-- Status Select -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="is_active">Status</label>
                <select 
                  class="form-control" 
                  id="is_active" 
                  v-model="form.is_active"
                >
                  <option :value="true">Active</option>
                  <option :value="false">Inactive</option>
                </select>
              </div>
            </div>

            <!-- Buttons -->
            <div class="form-row">
              <div class="form-group col-12 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" @click="cancelForm">
                  Cancel
                </button>
                <button type="submit" class="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <Keypad ref="keypad" />
  </div>
</template>

<script>
import Keypad from './keypad_popup_component.vue';
import { Modal } from 'bootstrap'; 

export default {
  components: {
    Keypad
  },
  data() {
    return {
      form: {
        name_en: '',
        name_ar: '',
        contact_person: '',
        contact_email: '',
        contact_phone: '',
        dealing_type: '1',
        branchId: localStorage.getItem('branchId') || 1,
        is_active: true
      },
      currentDate: '',
      currentTime: '',
      keypadModal: null,
      companyId: null,
      token: null
    };
  },
  mounted() {
    this.token = localStorage.getItem('authToken');
    this.companyId = this.$route.params.id;
    this.updateDateTime();
    this.startDateTimeUpdate();
    this.fetchDeliveryCompany();
    this.$nextTick(() => {
      const modalElement = this.$refs.keypad?.$el;
      if (modalElement) {
        this.keypadModal = new Modal(modalElement);
      }
    });
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      this.currentTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    },
    startDateTimeUpdate() {
      setInterval(() => {
        this.updateDateTime();
      }, 1000);
    },
    async fetchDeliveryCompany() {
      try {
        this.$root.isLoading = true; 
        this.loading = true;
        const response = await fetch(`${this.$BASE_API_URL}/api/delivery_companies/${this.companyId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch delivery company data');
        }

        const { data } = await response.json();
        this.form.name_en = data.name_en;
        this.form.name_ar = data.name_ar;
        this.form.is_active = data.is_active;
        this.form.branchId = data.branchId;
        this.form.contact_person = data.contact_person || '';
        this.form.contact_email = data.contact_email || '';
        this.form.contact_phone = data.contact_phone || '';
        this.form.dealing_type = data.dealing_type || '1';
      } catch (error) {
        console.error('Error fetching delivery company:', error);
        this.$toast.error('Failed to load delivery company details. Please try again.');
      }
      finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    openKeypad(inputRef) {
      this.$refs.keypad.setTargetInput(this.$refs[inputRef]);
      this.keypadModal.show();
    },
    cancelForm() {
      this.$router.push('/delivery_companies');
    },
    async handleUpdate() {
      try {
        this.$root.isLoading = true; 
        this.loading = true;
        const response = await fetch(`${this.$BASE_API_URL}/api/delivery_companies/${this.companyId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
          },
          body: JSON.stringify(this.form)
        });

        const data = await response.json();

        if (response.ok) {
          this.$toast.success('Delivery company updated successfully!');
          this.$router.push('/delivery_companies');
        } else {
          this.$toast.error('Update failed: ' + (data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error:', error);
        this.$toast.error('An error occurred. Please try again.');
      }
      finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.class-1 {
  font-family: 'Poppins', sans-serif;
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.form-control {
  height: calc(2.25rem + 12px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.input-group-text {
  cursor: pointer;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}

.btn {
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

.fa-keyboard {
  font-size: 1rem;
}
</style>